import React from 'react'
import './OurMission.component.scss'

const OurMission = () => {
  return (
    <section className='our-mission'>
      <div className='our-mission__inner'>
        <div className='our-mission__heading-col'>
          <h2 className='our-mission__title'>
            <span>Our Mission</span>
          </h2>
        </div>
        <div className='our-mission__body-col'>
          <p className='our-mission__text'>
            <span>
              USA Benefits Group is a nationwide marketing company dedicated to the principles of service, integrity,
              professionalism and diversity. Our affiliated independent agents provide an extensive range of insurance
              products and pledge to honor our commitment to the clients and carriers by holding themselves to the
              highest ethical standards. Everything that we do is designed to ensure that our customers are presented
              quality products with a Servant's Heart and a goal of exceeding expectations.
            </span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurMission
